$(document).ready(function(){

    $('.press_box').on('click', function () {
        $('body').toggleClass('fixed');
        $('.overlayy').toggleClass('fixed');
        $(this).toggleClass('zoom');
    });

    // Mobile Menu
    $('#toggle').click(function() {
       $(this).toggleClass('active');
       $('#overlay').toggleClass('open');
       $('body').toggleClass('fixed');
    });

    // Slider
    // Auction Detail
    if($('body').hasClass('homepage') || $('body').hasClass('valuations')) {

        $(".royalSlider").royalSlider({
            autoHeight: false,
            navigateByClick: true,
            arrowsNav: true,
            fadeinLoadedSlide: false,
            controlNavigationSpacing: 0,
            imageScaleMode: 'fill',
            controlNavigation: 'none',
            imageAlignCenter: true,
            loop: true,
            keyboardNavEnabled: true,
            arrowsNavAutoHide: false,
            autoPlay: {
                enabled: true,
                pauseOnHover: true,
                delay: 6000
            }
        });

    }

    /*$('.slider_product').slick({
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true
    });

    $('.slider_product').slickLightbox({
      itemSelector        : 'a',
      navigateByKeyboard  : true
    });*/

     $('.slider_records_auctions').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }]
    });

    $('.slider_upcoming_auctions').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }]
    });

    $('.slider_past_auctions').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        responsive: [{
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true
          }
        }]
    });

    // Login account errors smooth scroll
    /*$('.submit_btn').click(function() {
        $('html, body').animate({
            scrollTop: $('.box_account').offset().top
        }, 600);
    });*/

    // Auction Detail
    if($('body').hasClass('auction_detail')) {

        // Isotope
        var $grid = $('#auction_items').isotope({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.item',
            percentPosition: true,
            getSortData: {
                name: '.name',
                price: '.price parseInt',
                reference: '.reference parseInt',
                weight: function( itemElem ) {
                  var weight = $( itemElem ).find('.weight').text();
                  return parseFloat( weight.replace( /[\(\)]/g, '') );
                  }
            }
        });

        $('#categories').change(function() {
            var cat = $(this).val();
            $grid.isotope({
                filter: '.'+cat
            })
        })

        $('#artists').change(function() {
            var cat = $(this).val();
            $grid.isotope({
                filter: '.'+cat
            })
        })

        $('#sort_by').change(function() {
            var sort = $(this).val();
            $grid.isotope({
                sortBy: sort
            })
        })
    }

    // Auction Item Detail
    if($('body').hasClass('auction_item_detail')) {

        // When the user clicks on the bid button, open the modal
        $('#bid_trigger').click(function(e) {
            $('#bid_modal').addClass('visible');
            e.preventDefault();
        })

        // When the user clicks on <span> (x), close the modal
        $('#close_modal').click(function() {
            $('#bid_modal').removeClass('visible');
        })

        // Open modal if error message
        if($('#bid_modal').attr('data-open')=='open') {
            $('#bid_modal').addClass('visible');
        }

        $('.numeric').numeric({
            negative : false,
            decimal : '.',
            altDecimal : ','
        });

        $('#gallery').royalSlider({
            fullscreen: {
                enabled: true,
                nativeFS: true
            },
            controlNavigation: 'thumbnails',
            autoScaleSlider: true,
            autoScaleSliderHeight: 650,
            loop: true,
            imageScaleMode: 'fit-if-smaller',
            navigateByClick: true,
            numImagesToPreload:2,
            arrowsNav:true,
            arrowsNavAutoHide: true,
            arrowsNavHideOnTouch: true,
            keyboardNavEnabled: true,
            fadeinLoadedSlide: true,
            globalCaption: false,
            globalCaptionInside: false,
            thumbs: {
                appendSpan: true,
                firstMargin: true,
                paddingBottom: 4
            }
        });

        $('.rsContainer').on('touchmove touchend', function(){});

    }



});

$(window).resize(function() {

});

function recaptcha_callback(token) {
    $('.g-recaptcha-response').val(token);
}

function readURL(input) {
    if (input.files && input.files[0]) {
        $(".fa-upload").addClass("uploaded");
    }else{
        $(".fa-upload").removeClass("uploaded").addClass("upload_error");
    }
}

$('#inputFile').change(function () {
    readURL(this);
    var selectedFile = $(this).val().replace(/C:\\fakepath\\/i, '');
    $( ".file_name" ).html( selectedFile );
});


// var fileInput = $("#inputFile");
// if (fileInput.get(0).files.length) {
//     $("#errorNoFile").removeClass("errorMsg_step_2");
//     var arrInfos = fileInput.get(0).files[0].name.split('.');
//     var extention = arrInfos[(arrInfos.length) - 1].toLowerCase();
//     var arrayAuthorized = ["jpg", 'jpeg', 'png'];
//     if (arrayAuthorized.indexOf(extention) !== -1) {
//         $("#errorTypeFile").removeClass("errorMsg_step_2");
//         console.log('elo');
//         // var fileSize = fileInput.get(0).files[0].size; // in bytes
//         var fileSize = parseFloat(fileInput.get(0).files[0].size / 1024 / 1024 + "MB").toFixed(2);
//         if (fileSize > 2) {
//             arrayError.push(true);
//             $("#errorMaxFileSize").addClass("errorMsg_step_2");
//         } else {
//             $("#errorMaxFileSize").removeClass("errorMsg_step_2");
//             $("#errorNoFile").removeClass("errorMsg_step_2");
//         }
//     } else {
//         $("#errorTypeFile").addClass("errorMsg_step_2");
//     }
// }
